import { Injectable } from '@angular/core';
import * as moment from 'moment';
import {unix} from 'moment';

@Injectable({
  providedIn: 'root'
})
export class TimeService {

  constructor() { }
  convertDate(yourDate){
      let formattedDate = (moment(yourDate)).format('DD-MMM-YYYY HH:mm:ss')
      return formattedDate

  }
  convert_unix_epoch_s_to_ms(unix_epoc_s:number){
        let time = new Date().getTime() - new Date(moment(unix(unix_epoc_s).format('X'),'X').format('YYYY-MM-DDTHH:mm:ss')).getTime();
        let timeDiff = this.timeConversion(time)['0'];
        return time
    }
  timeConversion(duration: number) {
      const portions: string[] = [];

      const msInYear = 1000 * 60 * 60 * 24 * 365;
      const year = Math.trunc(duration / msInYear);
      if (year > 0) {
        portions.push(year + ' yrs ago');
        return portions

        duration = duration - (year * msInYear);

      }
      const msInDay = 1000 * 60 * 60 * 24;
      const days = Math.trunc(duration / msInDay);
      if (days > 0) {
        portions.push(days + ' days ago' );
        return portions
        duration = duration - (days * msInDay);
      }

      const msInHour = 1000 * 60 * 60;
      const hours = Math.trunc(duration / msInHour);
      if (hours > 0) {
        portions.push(hours + ' hrs ago');
        return portions
        duration = duration - (hours * msInHour);
      }

      const msInMinute = 1000 * 60;
      const minutes = Math.trunc(duration / msInMinute);
      if (minutes > 0) {
        portions.push(minutes + ' min ago');
        return portions

        duration = duration - (minutes * msInMinute);
      }
      const msInSeconds = 1000 ;
      const seconds = Math.trunc(duration / msInSeconds);
      if (seconds > 0) {

        portions.push(seconds + ' sec ago');
        return portions

        duration = duration - (seconds * msInSeconds);
      }

      return portions.join(' ');
    }
}
